// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint, LoadableBackground } from '@confluence/loadable';

export const CustomHeaderFooterLoader: LoadableType<{
	type: 'header' | 'footer';
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CustomHeaderFooter" */ './CustomHeaderFooter.tsx'))
			.CustomHeaderFooter,
});

export { CustomFooterLoader } from './CustomFooterLoader.tsx';

export const CustomHeaderFooterBackgroundLoader: LoadableType<{
	type: 'header' | 'footer';
}> = LoadableBackground({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CustomHeaderFooter" */ './CustomHeaderFooter.tsx'))
			.CustomHeaderFooter,
});

export { CUSTOM_HEADER_FOOTER_TYPES } from './constants.ts';
